/* =========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== */

import jwt from '../../http/requests/auth/jwt/index.js';
import constants from '../../../constant';
import router from '@/router';
import axios from '@/axios.js';
import api from '../../http/api/api.js';
export default {
  sendingOtp({ commit }, payload) {
    const { email, meeting_id } = payload;
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${constants.apiCastUrl}/api/event/send/otp/?email=${email}&cast_id=${meeting_id}`
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  verifyingOtp({ commit }, payload) {
    const { email, otp, meeting_id } = payload;
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${constants.apiCastUrl}/api/event/validate/otp/?email=${email}&cast_id=${meeting_id}&otp=${otp}`
        )
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  },
  async otpSent({ commit }, payload) {
    const email = payload.email;
    const userDetails = {
      email,
    };
    try {
      console.log('hello');
      const resObj = await axios.post(
        constants.apiUrl + `/api/send_otp/`,
        userDetails
      );
      console.log('resObj is', resObj.data);
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },
  login({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .login(
          payload.userDetails.password,
          payload.userDetails.email,
          payload.params.login_challenge
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  userRegister({ commit }, payload) {
    const { firstName, lastName, email, password } = payload.userDetails;

    return new Promise((resolve, reject) => {
      jwt
        .registerUser(firstName, lastName, email, password)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  googleRegister({ commit }, payload) {
    const { firstName, lastName, email, googleIdToken } = payload.userDetails;

    return new Promise((resolve, reject) => {
      jwt
        .registerUser(firstName, lastName, email, googleIdToken)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  registerUser({ commit }, payload) {
    const { firstName, lastName, email, password, confirmPassword } =
      payload.userDetails;

    return new Promise((resolve, reject) => {
      // Check confirm password
      if (password !== confirmPassword) {
        reject({ message: "Password doesn't match. Please try again." });
      }

      jwt
        .registerUser(firstName, lastName, email, password)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  verifyAuthToken({ commit }) {
    if (!localStorage.getItem('accessToken')) {
      return;
    }
    axios.get(`${constants.authApiBaseUrl}/api/v1/auth/me/?token=${localStorage.getItem('accessToken')}`)
      .then((res) => {
        if (!res.data.active) {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('accessToken');
          window.location.reload();
          // find a way to logout without refresh
          commit('LOGOUT', null, { root: true });
        }
      })
      .catch((error) => {
        console.log("Error while verifying token");
      });
  },
  logOut({ commit }) {
    const formData = new FormData();
    formData.append('token', localStorage.getItem("accessToken"));
    axios
      .post(`${constants.apiCastUrl}/api/revoke-token/`, formData)
      .then((res) => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('accessToken');
        window.location.reload();
        // find a way to logout without refresh
        commit('LOGOUT', null, { root: true });
      })
      .catch((error) => {
        console.log("Error while logging out");
      });
  },
  updateUserDetails({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .updateUser(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  changePassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .changePassword(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  fetchAccessToken() {
    return new Promise((resolve) => {
      jwt.refreshToken().then((response) => {
        console.log('response', response);
        resolve(response);
      });
    });
  },
  fetchUser({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_USER_INFO', payload, { root: true });
      commit('SET_BEARER', payload.access_token);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'register',
        authenticationMethod: 'Email',
        userId: payload.id,
      });
      resolve(true);
    });
  },
  fetched({ commit }) {
    return new Promise((resolve, reject) => {
      const user = JSON.parse(localStorage.getItem('userInfo'));
      const access = localStorage.getItem('accessToken');
      commit('UPDATE_USER_INFO', user, { root: true });
      commit('SET_BEARER', access);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'register',
        authenticationMethod: 'Email',
        userId: user.id,
      });
      resolve(true);
    });
  },
  sendOtp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .sendOtp(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  verifyOtp({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .verifyOtp(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // for Metamask
  getNonce({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .generateNonce(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  sendSignature({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .verifySignature(payload)
        .then((response) => {
          console.log('response');
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  //metamask wallet address
  saveWalletAddress({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .saveAddress(payload)
        .then((res) => {
          commit('GET_WALLET_ADDRESS', res.data.status);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  removeWalletAddress({ commit }, val) {
    commit('GET_WALLET_ADDRESS', val);
    return val;
  },

  addURLS({ commit }, data) {
    commit('ADD_URLS', data);
    return true;
  },
  setOpen({ commit }, data) {
    commit('SET_OPEN', true);
    return true;
  },
  eventDetail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .eventDetail(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  submitSheet({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .submitSheet(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  sendResetEmail({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .sendResetEmail(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  resetPassword({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .resetPassword(payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // this is for registration
  sendAccessTokenReg({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .generateAccessToken(payload)
        .then((response) => {
          // If there's user data in response
          if (response.data.usersData) {
            // Set accessToken
            localStorage.setItem('accessToken', response.data.accessToken);

            // Extracting first and last name from the username
            const userData = response.data.usersData;
            const nameParts = userData.username.split(' ');
            if (nameParts.length > 1) {
              userData.firstName = nameParts.slice(0, -1).join(' ');
              userData.lastName = nameParts[nameParts.length - 1];
            } else {
              userData.firstName = userData.username;
              userData.lastName = '';
            }

            // Updating userdetails with first and last name
            commit('UPDATE_USER_INFO', userData, { root: true });

            // Set bearer token in axios
            commit('SET_BEARER', response.data.accessToken);

            resolve(response);
          } else {
            reject({ message: 'Wrong Email or Password' });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  sendAccessToken({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .generateAccessToken(payload)
        .then((response) => {
          resolve(response);
          // If there's user data in response
          if (response.data.usersData) {
            const userData = response.data.usersData;
            commit('UPDATE_USER_INFO', userData, { root: true });

            commit('SET_BEARER', response.data.accessToken);
          } else {
            reject({ message: 'Wrong Email or Password' });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  contactUs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt
        .contactUs(payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  },

  //v2auth-apis
  v2verifyAuthToken({ commit }) {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      return;
    }
    axios.get(`${constants.authApiBaseUrl}/api/v1/auth/me/`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }).then((res) => {
      if (res && res.data) {
        const userData = res.data;
        commit('UPDATE_USER_INFO', userData, { root: true });
      } else {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken'); // optional: clear refresh token too
        commit('LOGOUT', null, { root: true });
      }
    }).catch((error) => {
      console.log("Error while verifying token", error);
    });
  },
  v2get2FaActivationKey({ commit }, payload) {
    return new Promise((resolve, reject) => {
      jwt.v2get2FaActivationKey()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  v2enable2fa({ commit }, payload) {
    const { key, code } = payload;
    return new Promise((resolve, reject) => {
      jwt.v2enable2fa(key, code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  v2disable2fa({ commit }, payload) {
    const { code } = payload;
    return new Promise((resolve, reject) => {
      jwt.v2disable2fa(code)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  v2registerUser({ commit }, payload) {
    const { firstName, lastName, email, password } = payload.userDetails;
    return new Promise((resolve, reject) => {
      jwt.v2registerUser(firstName, lastName, email, password)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  v2loginUser({ commit }, payload) {
    const { email, password } = payload.userDetails;
    return new Promise((resolve, reject) => {
      jwt.v2loginUser(email, password)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (!isTwoFactorAuthEnabled) {
            const userData = response.data?.user;
            const accessToken = response.data?.token;
            const refreshToken = response.data?.refreshToken;
            if (userData) {
              localStorage.setItem('accessToken', accessToken);
              localStorage.setItem('refreshToken', refreshToken);

              commit('UPDATE_USER_INFO', userData, { root: true });
              commit('SET_BEARER', accessToken);
            }
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  v2loginWith2FA({ commit }, payload) {
    const { code, token } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/2fa/login/`,
        {
          code: code
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then((response) => {
          const userData = response.data?.user; // adjust according to your actual response
          const accessToken = response.data?.token;
          const refreshToken = response.data?.refreshToken;
          if (userData) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            commit('UPDATE_USER_INFO', userData, { root: true });
            commit('SET_BEARER', accessToken);
          }
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  v2sendForgetPasswordLink({ commit }, payload) {
    const { email } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/forgot/password/`,
        { email: email }
      ).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2changePassword({ commit }, payload) {
    const { password, hash } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/reset/password/`,
        { password, hash }
      ).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2sendMagicLink({ commit }, payload) {
    const { email } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/email/login/otp/get`,
        { email: email }
      ).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2loginWithMagicLink({ commit }, payload) {
    const { hash } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/email/login/otp`,
        { hash }
      ).then((response) => {
        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
        if (!isTwoFactorAuthEnabled) {
          const userData = response.data?.user;
          const accessToken = response.data?.token;
          const refreshToken = response.data?.refreshToken;
          if (userData) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            commit('UPDATE_USER_INFO', userData, { root: true });
            commit('SET_BEARER', accessToken);
          }
        }
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2loginWithGoogle({ commit }, payload) {
    const { token } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/google/login`,
        { idToken: token }
      ).then((response) => {
        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
        if (!isTwoFactorAuthEnabled) {
          const userData = response.data?.user;
          const accessToken = response.data?.token;
          const refreshToken = response.data?.refreshToken;
          if (userData) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            commit('UPDATE_USER_INFO', userData, { root: true });
            commit('SET_BEARER', accessToken);
          }
        }
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2ConnectWithGoogle({ commit }, payload) {
    const { token } = payload;
    return new Promise((resolve, reject) => {
      api.post(`${constants.authApiBaseUrl}/api/v1/auth/google/connect`,
        { idToken: token }
      ).then((response) => {
        const userData = response.data?.user;
        const accessToken = response.data?.token;
        const refreshToken = response.data?.refreshToken;
        if (userData) {
          localStorage.setItem('accessToken', accessToken)
          localStorage.setItem('refreshToken', refreshToken)
          commit('UPDATE_USER_INFO', userData, { root: true });
          commit('SET_BEARER', accessToken);
        }
        console.log('Google connect response:', response);
        resolve(response);
      }).catch((error) => {
        console.error('Error connecting with Google:', error);
        reject(error);
      });
    });
  },
  v2verifyEmailAccount({ commit }, payload) {
    const { hash } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/email/confirm`,
        { hash }
      ).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  // v2logOut({ commit }) {
  //   const formData = new FormData();
  //   formData.append('token', localStorage.getItem("accessToken"));
  //   axios
  //     .post(`${constants.apiCastUrl}/api/revoke-token/`, formData)
  //     .then((res) => {
  //       localStorage.removeItem('userInfo');
  //       localStorage.removeItem('accessToken');
  //       window.location.reload();
  //       // find a way to logout without refresh
  //       commit('LOGOUT', null, { root: true });
  //     })
  //     .catch((error) => {
  //       console.log("Error while logging out");
  //     });
  // },
  v2logOut({ commit }) {
    return new Promise((resolve, reject) => {
      jwt
        .v2logOut()
        .then((response) => {
          localStorage.removeItem('userInfo');
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          window.location.reload();
          // You can redirect to login page or clear app state instead of reloading
          commit('LOGOUT', null, { root: true });
          // Optional: route to login or landing page
          // this.$router.push({ name: 'login' });
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  //v2auth-metamask
  v2getNonce({ commit }, payload) {
    const { address } = payload;
    return new Promise((resolve, reject) => {
      jwt
        .v2generateNonce(address)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  v2sendSignature({ commit }, payload) {
    const { token, signature } = payload;
    return new Promise((resolve, reject) => {
      jwt
        .v2verifySignature(token, signature)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (!isTwoFactorAuthEnabled) {
            const userData = response.data?.user;
            const accessToken = response.data?.token;
            const refreshToken = response.data?.refreshToken;
            if (userData) {
              localStorage.setItem('accessToken', accessToken);
              localStorage.setItem('refreshToken', refreshToken);

              commit('UPDATE_USER_INFO', userData, { root: true });
              commit('SET_BEARER', accessToken);
            }
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  v2sendSignatureConnect({ commit }, payload) {
    const { token, signature } = payload;
    return new Promise((resolve, reject) => {
      jwt
        .v2verifyConnect(token, signature)
        .then((response) => {
          const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
          if (!isTwoFactorAuthEnabled) {
            const userData = response.data?.user;
            const accessToken = response.data?.token;
            const refreshToken = response.data?.refreshToken;
            if (userData) {
              localStorage.setItem('accessToken', accessToken)
              localStorage.setItem('refreshToken', refreshToken)
              commit('UPDATE_USER_INFO', userData, { root: true });
              commit('SET_BEARER', accessToken);
            }
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  //Did APIS
  v2getDidNonce({ commit }, payload) {
    const did = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/did/nonce`,
        did
      ).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2loginWithDid({ commit }, payload) {
    const {
      token,
      signature,
      didDocument,
      username
    } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/did/login`,
        {
          token,
          signature,
          didDocument,
          username
        }
      ).then((response) => {
        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
        if (!isTwoFactorAuthEnabled) {
          const userData = response.data?.user;
          const accessToken = response.data?.token;
          const refreshToken = response.data?.refreshToken;
          if (userData) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            commit('UPDATE_USER_INFO', userData, { root: true });
            commit('SET_BEARER', accessToken);
          }
        }
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2verifyDidJwt({ commit }, payload) {
    const { didJwt, audience } = payload;
    return new Promise((resolve, reject) => {
      axios.post(`${constants.authApiBaseUrl}/api/v1/auth/did-jwt`,
        { didJwt, audience }
      ).then((response) => {
        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
        if (!isTwoFactorAuthEnabled) {
          const userData = response.data?.user;
          const accessToken = response.data?.token;
          const refreshToken = response.data?.refreshToken;
          if (userData) {
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);

            commit('UPDATE_USER_INFO', userData, { root: true });
            commit('SET_BEARER', accessToken);
          }
        }
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2updateUserInfo({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.patch(`${constants.authApiBaseUrl}/api/v1/auth/me`, payload
      ).then((response) => {
        const userData = response?.data;
        commit('UPDATE_USER_INFO', userData, { root: true });
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  v2fetchLinkedIdentities({ commit }) {
    return new Promise((resolve, reject) => {
      api.get(`${constants.authApiBaseUrl}/api/v1/auth/me`)
        .then((response) => {
          const userData = response?.data;
          if (userData) {
            commit('UPDATE_USER_INFO', userData, { root: true });
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  v2ConnectDid({ commit }, payload) {
    const { token, signature, didDocument } = payload;
    return new Promise((resolve, reject) => {
      api.post(`${constants.authApiBaseUrl}/api/v1/auth/did/connect`, {
        token,
        signature,
        didDocument,
      }).then((response) => {
        const userData = response.data?.user;
        const accessToken = response.data?.token;
        const refreshToken = response.data?.refreshToken;
        if (userData) {
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
          commit('UPDATE_USER_INFO', userData, { root: true });
          commit('SET_BEARER', accessToken);
        }
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};

//v2ConnectWithGoogle
